import * as THREE from 'three';
import GUI from 'lil-gui';
import gsap from 'gsap';

// ★ canvas毎の設定をMapで管理
const configMap = new Map<
  string,
  {
    waveParams: {
      xWave1Amplitude: number;
      xWave1Frequency: number;
      xWave1Speed: number;
      xWave2Amplitude: number;
      xWave2Frequency: number;
      xWave2Speed: number;
      zWave1Amplitude: number;
      zWave1Frequency: number;
      zWave1Speed: number;
      zWave2Amplitude: number;
      zWave2Frequency: number;
      zWave2Speed: number;
      yWave1Amplitude: number;
      yWave1Frequency: number;
      yWave1Speed: number;
      yWave2Amplitude: number;
      yWave2Frequency: number;
      yWave2Speed: number;
    };
    cameraParams: {
      x: number;
      y: number;
      z: number;
    };
    drawAnimationDuration: number; // 描画アニメーションの時間（秒）
  }
>([
  [
    'slide01Num01',
    {
      waveParams: {
        xWave1Amplitude: 0.0,
        xWave1Frequency: 0.0,
        xWave1Speed: 0.0,
        xWave2Amplitude: 0.0,
        xWave2Frequency: 0.0,
        xWave2Speed: 0.0,
        //
        zWave1Amplitude: 1,
        zWave1Frequency: 16,
        zWave1Speed: 4,
        zWave2Amplitude: 1,
        zWave2Frequency: 16,
        zWave2Speed: 4,
        //
        yWave1Amplitude: 0.1,
        yWave1Frequency: 8,
        yWave1Speed: 3,
        yWave2Amplitude: 0.1,
        yWave2Frequency: 10,
        yWave2Speed: 2,
      },
      cameraParams: {
        x: 2,
        y: 0.8,
        z: 1.2,
      },
      drawAnimationDuration: 2,
    },
  ],
  [
    'slide01Num02',
    {
      waveParams: {
        xWave1Amplitude: 0.15,
        xWave1Frequency: 0.4,
        xWave1Speed: 1.8,
        xWave2Amplitude: 0.25,
        xWave2Frequency: 0.7,
        xWave2Speed: 2.2,
        //
        zWave1Amplitude: 0.5,
        zWave1Frequency: 14,
        zWave1Speed: 4,
        zWave2Amplitude: 0.5,
        zWave2Frequency: 16,
        zWave2Speed: 5,
        //
        yWave1Amplitude: 0.25,
        yWave1Frequency: 9,
        yWave1Speed: 3.2,
        yWave2Amplitude: 0.25,
        yWave2Frequency: 11,
        yWave2Speed: 2.7,
      },
      cameraParams: {
        x: 0.8,
        y: 1.1,
        z: -0.8,
      },
      drawAnimationDuration: 3,
    },
  ],
  [
    'slide01Num03',
    {
      waveParams: {
        xWave1Amplitude: 0.12,
        xWave1Frequency: 0.35,
        xWave1Speed: 1.7,
        xWave2Amplitude: 0.22,
        xWave2Frequency: 0.65,
        xWave2Speed: 2.1,
        //
        zWave1Amplitude: 0.7,
        zWave1Frequency: 14,
        zWave1Speed: 5,
        zWave2Amplitude: 0.6,
        zWave2Frequency: 18,
        zWave2Speed: 4,
        //
        yWave1Amplitude: 0.4,
        yWave1Frequency: 15,
        yWave1Speed: 4,
        yWave2Amplitude: 0.3,
        yWave2Frequency: 18,
        yWave2Speed: 3,
      },
      cameraParams: {
        x: 0.75,
        y: 1.05,
        z: -3.5,
      },
      drawAnimationDuration: 2,
    },
  ],
  [
    'slide02Num01',
    {
      waveParams: {
        xWave1Amplitude: 0.08,
        xWave1Frequency: 0.25,
        xWave1Speed: 1.4,
        xWave2Amplitude: 0.18,
        xWave2Frequency: 0.55,
        xWave2Speed: 1.9,
        //
        zWave1Amplitude: 0.6,
        zWave1Frequency: 12,
        zWave1Speed: 2,
        zWave2Amplitude: 0.8,
        zWave2Frequency: 10,
        zWave2Speed: 3,
        //
        yWave1Amplitude: 0.1,
        yWave1Frequency: 1,
        yWave1Speed: 2,
        yWave2Amplitude: 0.1,
        yWave2Frequency: 1,
        yWave2Speed: 1,
      },
      cameraParams: {
        x: 5.5,
        y: 0.3,
        z: 0,
      },
      drawAnimationDuration: 3,
    },
  ],
  [
    'slide02Num02',
    {
      waveParams: {
        xWave1Amplitude: 0.08,
        xWave1Frequency: 0.25,
        xWave1Speed: 1.4,
        xWave2Amplitude: 0.18,
        xWave2Frequency: 0.55,
        xWave2Speed: 1.9,
        //
        zWave1Amplitude: 0.8,
        zWave1Frequency: 8.5,
        zWave1Speed: 4,
        zWave2Amplitude: 0.6,
        zWave2Frequency: 8.5,
        zWave2Speed: 2.8,
        //
        yWave1Amplitude: 0.3,
        yWave1Frequency: 7.5,
        yWave1Speed: 2.8,
        yWave2Amplitude: 0.18,
        yWave2Frequency: 9.5,
        yWave2Speed: 4,
      },
      cameraParams: {
        x: 0.65,
        y: 0.95,
        z: -1.2,
      },
      drawAnimationDuration: 2,
    },
  ],
  [
    'slide02Num03',
    {
      waveParams: {
        xWave1Amplitude: 0.08,
        xWave1Frequency: 0.25,
        xWave1Speed: 1.4,
        xWave2Amplitude: 0.18,
        xWave2Frequency: 0.55,
        xWave2Speed: 1.9,
        //
        zWave1Amplitude: 0.8,
        zWave1Frequency: 12,
        zWave1Speed: 3,
        zWave2Amplitude: 1.2,
        zWave2Frequency: 16,
        zWave2Speed: 2,
        //
        yWave1Amplitude: 0.1,
        yWave1Frequency: 5,
        yWave1Speed: 1.5,
        yWave2Amplitude: 0.2,
        yWave2Frequency: 7,
        yWave2Speed: 1,
      },
      cameraParams: {
        x: 0.9,
        y: -0.8,
        z: 1.1,
      },
      drawAnimationDuration: 2,
    },
  ],
  [
    'slide03Num01',
    {
      waveParams: {
        xWave1Amplitude: 0.08,
        xWave1Frequency: 0.25,
        xWave1Speed: 1.4,
        xWave2Amplitude: 0.18,
        xWave2Frequency: 0.55,
        xWave2Speed: 1.9,
        //
        zWave1Amplitude: 0.8,
        zWave1Frequency: 12,
        zWave1Speed: 4,
        zWave2Amplitude: 0.6,
        zWave2Frequency: 9,
        zWave2Speed: 2.8,
        //
        yWave1Amplitude: 0.18,
        yWave1Frequency: 3,
        yWave1Speed: 2.8,
        yWave2Amplitude: 0.18,
        yWave2Frequency: 5,
        yWave2Speed: 2.3,
      },
      cameraParams: {
        x: 0.5,
        y: 0.6,
        z: -1,
      },
      drawAnimationDuration: 3,
    },
  ],
  [
    'slide03Num02',
    {
      waveParams: {
        xWave1Amplitude: 0.08,
        xWave1Frequency: 0.25,
        xWave1Speed: 1.4,
        xWave2Amplitude: 0.18,
        xWave2Frequency: 0.55,
        xWave2Speed: 1.9,
        //
        zWave1Amplitude: 0.5,
        zWave1Frequency: 9,
        zWave1Speed: 4,
        zWave2Amplitude: 0.7,
        zWave2Frequency: 10,
        zWave2Speed: 3,
        //
        yWave1Amplitude: 0.18,
        yWave1Frequency: 7.5,
        yWave1Speed: 2.8,
        yWave2Amplitude: 0.18,
        yWave2Frequency: 9.5,
        yWave2Speed: 2.3,
      },
      cameraParams: {
        x: 0.7,
        y: 1.1,
        z: 1.3,
      },
      drawAnimationDuration: 2,
    },
  ],
]);

// デフォルト設定
const defaultConfig = {
  waveParams: {
    xWave1Amplitude: 0.1,
    xWave1Frequency: 0.3,
    xWave1Speed: 1.6,
    xWave2Amplitude: 0.2,
    xWave2Frequency: 0.6,
    xWave2Speed: 2,
    //
    zWave1Amplitude: 0.4,
    zWave1Frequency: 9,
    zWave1Speed: 2,
    zWave2Amplitude: 0.4,
    zWave2Frequency: 9,
    zWave2Speed: 3,
    //
    yWave1Amplitude: 0.2,
    yWave1Frequency: 8,
    yWave1Speed: 3,
    yWave2Amplitude: 0.2,
    yWave2Frequency: 10,
    yWave2Speed: 2.5,
  },
  cameraParams: {
    x: 0.7,
    y: 1,
    z: 1.1,
  },
  drawAnimationDuration: 2,
};

const props = {
  canvasSel: '.js-canvasHomeMv',
  lineCount: 40,
  lineSpacing: 0.035,
  colors: ['#A3C3F8', '#167AE7', '#1630c6', '#66A4F5', '#687df4'],
} as const;

type State = {
  canvasEl: HTMLCanvasElement;
  canvasName: string; // ★ data-name を保持
  config: typeof defaultConfig; // ★ 個別の設定
  scene: THREE.Scene;
  camera: THREE.PerspectiveCamera;
  renderer: THREE.WebGLRenderer | null;
  lineGroup: THREE.Group | null;
  animationFrameId: number | null;
  resizeHandler: ((this: Window, ev: UIEvent) => void) | null;
  isInView: boolean;
  isActive: boolean;
  observer: IntersectionObserver | null;
  isFirstActivation: boolean; // 初回アクティブ化フラグ
  drawProgress: number; // ライン描画進行度 (0〜1)
  isDrawing: boolean; // 描画アニメーション中フラグ
};

const states: State[] = [];

const guiState: {
  gui: GUI | undefined;
  guiFrameEl: HTMLElement | null;
  enabled: boolean;
} = {
  gui: undefined,
  guiFrameEl: null,
  enabled: false,
};

const vertexShader = `
  varying float vAlpha;
  varying float vX;
  uniform float time;
  uniform float lineIndex;
  uniform float lineCount;
  uniform float lineSpacing;
  uniform float drawProgress;

  uniform float xWave1Amplitude;
  uniform float xWave1Frequency;
  uniform float xWave1Speed;
  uniform float xWave2Amplitude;
  uniform float xWave2Frequency;
  uniform float xWave2Speed;
  uniform float zWave1Amplitude;
  uniform float zWave1Frequency;
  uniform float zWave1Speed;
  uniform float zWave2Amplitude;
  uniform float zWave2Frequency;
  uniform float zWave2Speed;
  uniform float yWave1Amplitude;
  uniform float yWave1Frequency;
  uniform float yWave1Speed;
  uniform float yWave2Amplitude;
  uniform float yWave2Frequency;
  uniform float yWave2Speed;

  void main() {
    vec3 pos = position;

    float lineOffset = (lineIndex - lineCount * 0.5) / lineCount;
    float spreadAmount = lineOffset * 0.4;

    float edgeFactor = smoothstep(-96.0, -90.0, pos.x) * smoothstep(96.0, 90.0, -pos.x);

    float phaseOffset = lineIndex * 0.2;
    float timeFactor = time + phaseOffset;

    float waveX1 = sin(pos.x * xWave1Frequency + time * xWave1Speed) * xWave1Amplitude;
    float waveX2 = sin(pos.x * xWave2Frequency + time * xWave2Speed) * xWave2Amplitude;
    float finalWaveX = (waveX1 + waveX2) * edgeFactor;

    float waveZ1 = cos(pos.x * zWave1Frequency + time * zWave1Speed) * zWave1Amplitude;
    float waveZ2 = cos(pos.x * zWave2Frequency + time * zWave2Speed) * zWave2Amplitude;
    float finalWaveZ = (waveZ1 + waveZ2) * edgeFactor;

    float waveY1 = sin(pos.x * yWave1Frequency + time * yWave1Speed) * yWave1Amplitude;
    float waveY2 = sin(pos.x * yWave2Frequency + time * yWave2Speed) * yWave2Amplitude;
    float finalWaveY = (waveY1 + waveY2) * edgeFactor;

    finalWaveX *= sin(timeFactor * 0.3) * 0.5 + 0.5;
    finalWaveY *= sin(timeFactor * 0.4) * 0.5 + 0.5;
    finalWaveZ *= cos(timeFactor * 0.3) * 0.5 + 0.5;

    pos.x += finalWaveX * 0.3;
    pos.y = finalWaveY;
    pos.z += finalWaveZ * 0.3 + spreadAmount;

    float edgeFade = smoothstep(-1.0, -0.9, position.x) * smoothstep(1.0, 0.9, position.x);
    float depthAlpha = 1.0 - abs(lineOffset) * 0.5;

    // ライン描画進行度による制御（右から左へ伸びる = 手前から奥へ）
    // position.x を -1.0 から 1.0 に正規化
    float normalizedPos = position.x / 1.0 + 0.4; // -1.0(左) to 1.0(右)

    // drawProgress を 1.0 から -1.0 の範囲に変換（逆転）
    // drawProgress=0 → threshold=1.0 (全て非表示、右端より右側のみ表示=なし)
    // drawProgress=0.5 → threshold=0.0 (右半分表示)
    // drawProgress=1.0 → threshold=-1.0 (全て表示)
    float threshold = 1.0 - drawProgress * 2.0;

    // normalizedPos が threshold より大きければ表示（右側が表示される）
    if (normalizedPos > threshold) {
      vAlpha = edgeFade * depthAlpha * 0.9;
      vX = pos.x;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
    } else {
      vAlpha = 0.0;
      gl_Position = vec4(0.0, 0.0, -1000.0, 1.0); // 画面外へ
    }
  }
`;

const fragmentShader = `
  uniform vec3 uColors[5];
  varying float vAlpha;
  varying float vX;
  uniform float time;

  void main() {
    float t = sin(vX * 2.0 + time * 1.5) * 0.5 + 0.25;

    vec3 color;
    if (t < 0.25) {
      color = mix(uColors[0], uColors[1], t / 0.25);
    } else if (t < 0.5) {
      color = mix(uColors[1], uColors[2], (t - 0.25) / 0.25);
    } else if (t < 0.75) {
      color = mix(uColors[2], uColors[3], (t - 0.5) / 0.25);
    } else {
      color = mix(uColors[3], uColors[4], (t - 0.75) / 0.25);
    }

    gl_FragColor = vec4(color, vAlpha);
  }
`;

export const waveLineMv = {
  init() {
    const canvasEls = document.querySelectorAll<HTMLCanvasElement>(props.canvasSel);
    if (!canvasEls.length) {
      throw new Error(`${props.canvasSel} が見つかりません`);
    }

    canvasEls.forEach((canvasEl) => {
      // ★ data-name を取得して設定を決定
      const canvasName = canvasEl.dataset.name || '';
      const config = configMap.get(canvasName) || defaultConfig;

      const state: State = {
        canvasEl,
        canvasName,
        config,
        scene: new THREE.Scene(),
        camera: new THREE.PerspectiveCamera(65, 1, 0.1, 10000),
        renderer: null,
        lineGroup: null,
        animationFrameId: null,
        resizeHandler: null,
        isInView: false,
        isActive: false,
        observer: null,
        isFirstActivation: true,
        drawProgress: 0,
        isDrawing: false,
      };

      // ★ 個別の設定を使用
      state.camera.position.x = config.cameraParams.x;
      state.camera.position.y = config.cameraParams.y;
      state.camera.position.z = config.cameraParams.z;
      state.camera.lookAt(0, 0, 0);

      state.renderer = new THREE.WebGLRenderer({
        canvas: state.canvasEl,
        antialias: true,
        alpha: true,
      });
      state.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));

      state.lineGroup = new THREE.Group();
      this.setMesh(state);

      state.scene.add(state.lineGroup);

      state.resizeHandler = () => this.onResize(state);
      window.addEventListener('resize', state.resizeHandler);
      this.onResize(state);

      // 初期描画を実行して、drawProgress=0の状態を表示（非表示状態）
      if (state.lineGroup && state.renderer && state.camera) {
        state.renderer.render(state.scene, state.camera);
        // console.log('Initial render for:', canvasName, 'drawProgress:', state.drawProgress);
      }

      this.setupIntersectionObserver(state);

      states.push(state);
      // console.log('✓ Canvas initialized:', state.canvasName, {
      //   isFirstActivation: state.isFirstActivation,
      //   isActive: state.isActive,
      //   isInView: state.isInView,
      // });
    });

    if (guiState.enabled && !guiState.gui) {
      this.setGUI();
    }

    // console.log('Calling updateActiveStates...');
    this.updateActiveStates();
  },

  setMesh(state: State) {
    if (!state.lineGroup) return;

    const { lineCount, lineSpacing } = props;

    for (let i = 0; i < lineCount; i++) {
      const points: THREE.Vector3[] = [];
      const segments = 128;
      for (let j = 0; j <= segments; j++) {
        const x = (j / segments) * 2 - 1;
        points.push(new THREE.Vector3(x, 0, 0));
      }

      const geometry = new THREE.BufferGeometry().setFromPoints(points);

      const colorVecs = props.colors.map((hex) => new THREE.Color(hex));
      const colorVectors = colorVecs.map((c) => new THREE.Vector3(c.r, c.g, c.b));

      // ★ state.config から個別の設定を取得
      const material = new THREE.ShaderMaterial({
        uniforms: {
          time: { value: 1.0 },
          lineIndex: { value: i },
          lineCount: { value: lineCount },
          lineSpacing: { value: lineSpacing },
          drawProgress: { value: 0 },
          uColors: { value: colorVectors },
          xWave1Amplitude: { value: state.config.waveParams.xWave1Amplitude },
          xWave1Frequency: { value: state.config.waveParams.xWave1Frequency },
          xWave1Speed: { value: state.config.waveParams.xWave1Speed },
          xWave2Amplitude: { value: state.config.waveParams.xWave2Amplitude },
          xWave2Frequency: { value: state.config.waveParams.xWave2Frequency },
          xWave2Speed: { value: state.config.waveParams.xWave2Speed },
          zWave1Amplitude: { value: state.config.waveParams.zWave1Amplitude },
          zWave1Frequency: { value: state.config.waveParams.zWave1Frequency },
          zWave1Speed: { value: state.config.waveParams.zWave1Speed },
          zWave2Amplitude: { value: state.config.waveParams.zWave2Amplitude },
          zWave2Frequency: { value: state.config.waveParams.zWave2Frequency },
          zWave2Speed: { value: state.config.waveParams.zWave2Speed },
          yWave1Amplitude: { value: state.config.waveParams.yWave1Amplitude },
          yWave1Frequency: { value: state.config.waveParams.yWave1Frequency },
          yWave1Speed: { value: state.config.waveParams.yWave1Speed },
          yWave2Amplitude: { value: state.config.waveParams.yWave2Amplitude },
          yWave2Frequency: { value: state.config.waveParams.yWave2Frequency },
          yWave2Speed: { value: state.config.waveParams.yWave2Speed },
        },
        vertexShader,
        fragmentShader,
        transparent: true,
        depthTest: false,
      });

      for (let k = 0; k < 2; k++) {
        const lineMaterial = material.clone();
        const line = new THREE.Line(geometry, lineMaterial);
        state.lineGroup.add(line);
      }
    }
  },

  setGUI() {
    guiState.gui = new GUI();

    // drawProgress テスト用コントロール
    const testControls = {
      drawProgress: 1.0,
    };

    const testFolder = guiState.gui.addFolder('Test Controls');
    testFolder
      .add(testControls, 'drawProgress', 0, 1, 0.01)
      .name('Draw Progress')
      .onChange((value: number) => {
        states.forEach((state) => {
          state.drawProgress = value;
          if (state.lineGroup) {
            state.lineGroup.children.forEach((line) => {
              const material = (line as THREE.Line).material as THREE.ShaderMaterial;
              material.uniforms.drawProgress.value = value;
            });
          }
        });
      });
    testFolder.open();

    guiState.gui
      .add(props, 'lineCount', 10, 80, 1)
      .name('Line Count')
      .onChange(() => {
        states.forEach((state) => {
          if (state.lineGroup) {
            state.lineGroup.clear();
            this.setMesh(state);
          }
        });
      });

    guiState.gui
      .add(props, 'lineSpacing', 0.01, 0.1, 0.005)
      .name('Spacing')
      .onChange(() => {
        states.forEach((state) => {
          if (state.lineGroup) {
            state.lineGroup.clear();
            this.setMesh(state);
          }
        });
      });

    const colorFolder = guiState.gui.addFolder('Colors');
    props.colors.forEach((color, index) => {
      colorFolder
        .addColor(props.colors, index)
        .name(`Color ${index + 1}`)
        .onChange(() => this.updateColors());
    });

    // ★ 各canvasの設定を個別に調整できるようにGUIを追加
    states.forEach((state, idx) => {
      const stateFolder = guiState.gui!.addFolder(`Canvas: ${state.canvasName || `#${idx}`}`);

      const xWaveFolder = stateFolder.addFolder('X Wave');
      xWaveFolder
        .add(state.config.waveParams, 'xWave1Amplitude', 0, 1, 0.01)
        .name('W1 Amp')
        .onChange(() => this.updateStateWaveParams(state));
      xWaveFolder
        .add(state.config.waveParams, 'xWave1Frequency', 0, 2, 0.1)
        .name('W1 Freq')
        .onChange(() => this.updateStateWaveParams(state));
      xWaveFolder
        .add(state.config.waveParams, 'xWave1Speed', 0, 5, 0.1)
        .name('W1 Speed')
        .onChange(() => this.updateStateWaveParams(state));
      xWaveFolder
        .add(state.config.waveParams, 'xWave2Amplitude', 0, 1, 0.01)
        .name('W2 Amp')
        .onChange(() => this.updateStateWaveParams(state));
      xWaveFolder
        .add(state.config.waveParams, 'xWave2Frequency', 0, 2, 0.1)
        .name('W2 Freq')
        .onChange(() => this.updateStateWaveParams(state));
      xWaveFolder
        .add(state.config.waveParams, 'xWave2Speed', 0, 5, 0.1)
        .name('W2 Speed')
        .onChange(() => this.updateStateWaveParams(state));

      const zWaveFolder = stateFolder.addFolder('Z Wave');
      zWaveFolder
        .add(state.config.waveParams, 'zWave1Amplitude', 0, 1, 0.01)
        .name('W1 Amp')
        .onChange(() => this.updateStateWaveParams(state));
      zWaveFolder
        .add(state.config.waveParams, 'zWave1Frequency', 0, 20, 0.1)
        .name('W1 Freq')
        .onChange(() => this.updateStateWaveParams(state));
      zWaveFolder
        .add(state.config.waveParams, 'zWave1Speed', 0, 5, 0.1)
        .name('W1 Speed')
        .onChange(() => this.updateStateWaveParams(state));
      zWaveFolder
        .add(state.config.waveParams, 'zWave2Amplitude', 0, 1, 0.01)
        .name('W2 Amp')
        .onChange(() => this.updateStateWaveParams(state));
      zWaveFolder
        .add(state.config.waveParams, 'zWave2Frequency', 0, 20, 0.1)
        .name('W2 Freq')
        .onChange(() => this.updateStateWaveParams(state));
      zWaveFolder
        .add(state.config.waveParams, 'zWave2Speed', 0, 5, 0.1)
        .name('W2 Speed')
        .onChange(() => this.updateStateWaveParams(state));

      const yWaveFolder = stateFolder.addFolder('Y Wave');
      yWaveFolder
        .add(state.config.waveParams, 'yWave1Amplitude', 0, 1, 0.01)
        .name('W1 Amp')
        .onChange(() => this.updateStateWaveParams(state));
      yWaveFolder
        .add(state.config.waveParams, 'yWave1Frequency', 0, 20, 0.1)
        .name('W1 Freq')
        .onChange(() => this.updateStateWaveParams(state));
      yWaveFolder
        .add(state.config.waveParams, 'yWave1Speed', 0, 5, 0.1)
        .name('W1 Speed')
        .onChange(() => this.updateStateWaveParams(state));
      yWaveFolder
        .add(state.config.waveParams, 'yWave2Amplitude', 0, 1, 0.01)
        .name('W2 Amp')
        .onChange(() => this.updateStateWaveParams(state));
      yWaveFolder
        .add(state.config.waveParams, 'yWave2Frequency', 0, 20, 0.1)
        .name('W2 Freq')
        .onChange(() => this.updateStateWaveParams(state));
      yWaveFolder
        .add(state.config.waveParams, 'yWave2Speed', 0, 5, 0.1)
        .name('W2 Speed')
        .onChange(() => this.updateStateWaveParams(state));

      const cameraFolder = stateFolder.addFolder('Camera');
      cameraFolder
        .add(state.config.cameraParams, 'x', -10, 10, 0.1)
        .name('X')
        .onChange(() => {
          state.camera.position.x = state.config.cameraParams.x;
          state.camera.updateProjectionMatrix();
        });
      cameraFolder
        .add(state.config.cameraParams, 'y', -10, 10, 0.1)
        .name('Y')
        .onChange(() => {
          state.camera.position.y = state.config.cameraParams.y;
          state.camera.updateProjectionMatrix();
        });
      cameraFolder
        .add(state.config.cameraParams, 'z', -10, 10, 0.1)
        .name('Z')
        .onChange(() => {
          state.camera.position.z = state.config.cameraParams.z;
          state.camera.updateProjectionMatrix();
        });
    });
  },

  // ★ 特定のstateのwaveパラメータを更新
  updateStateWaveParams(state: State) {
    if (!state.lineGroup) return;

    state.lineGroup.children.forEach((line) => {
      const material = (line as THREE.Line).material as THREE.ShaderMaterial;
      Object.entries(state.config.waveParams).forEach(([key, value]) => {
        if (material.uniforms[key]) {
          material.uniforms[key].value = value;
        }
      });
    });
  },

  updateColors() {
    const colorVecs = props.colors.map((hex) => new THREE.Color(hex));
    const colorVectors = colorVecs.map((c) => new THREE.Vector3(c.r, c.g, c.b));

    states.forEach((state) => {
      if (!state.lineGroup) return;
      state.lineGroup.children.forEach((line) => {
        const mat = (line as THREE.Line).material as THREE.ShaderMaterial;
        if (mat.uniforms.uColors) {
          for (let i = 0; i < 5; i++) {
            mat.uniforms.uColors.value[i].copy(colorVectors[i]);
          }
        }
      });
    });
  },

  onResize(state: State) {
    if (!state.renderer || !state.camera || !state.lineGroup || !state.canvasEl) return;

    const w = state.canvasEl.clientWidth;
    const h = state.canvasEl.clientHeight;

    state.renderer.setSize(w, h, false);
    state.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));

    state.camera.aspect = w / h;
    state.camera.updateProjectionMatrix();

    if (state.lineGroup) {
      state.lineGroup.scale.set(state.camera.aspect * 4, 0.75, 1);
    }
  },

  setupIntersectionObserver(state: State) {
    if (!state.canvasEl) return;

    state.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          state.isInView = entry.isIntersecting;
          this.checkAndToggleAnimation(state);
        });
      },
      {
        threshold: 0,
      },
    );

    state.observer.observe(state.canvasEl);
  },

  startDrawAnimation(state: State) {
    if (!state.lineGroup) return;

    // console.log('🎨 startDrawAnimation called for:', state.canvasName);

    state.isDrawing = true;
    state.drawProgress = 0;

    // 全ラインのdrawProgress uniformを0に設定
    state.lineGroup.children.forEach((line) => {
      const material = (line as THREE.Line).material as THREE.ShaderMaterial;
      material.uniforms.drawProgress.value = 0;
    });

    // 描画アニメーション中も波アニメーションを実行
    this.animateDrawing(state);

    // GSAPで描画進行度をアニメーション（canvas毎の設定を使用）
    // console.log('   Starting GSAP animation (0 → 1)...');
    gsap.to(state, {
      drawProgress: 1,
      duration: state.config.drawAnimationDuration, // canvas毎の設定を使用
      delay: 0.4,
      ease: 'linear',
      // onStart: () => {
      //   console.log('   GSAP onStart: drawProgress =', state.drawProgress);
      // },
      onUpdate: () => {
        // console.log('   GSAP onUpdate: drawProgress =', state.drawProgress);
        if (!state.lineGroup) return;
        // 全ラインのuniformを更新
        state.lineGroup.children.forEach((line) => {
          const material = (line as THREE.Line).material as THREE.ShaderMaterial;
          material.uniforms.drawProgress.value = state.drawProgress;
          // console.log('     uniform updated:', material.uniforms.drawProgress.value);
        });
      },
      onComplete: () => {
        // console.log('   ✓ Draw animation completed for:', state.canvasName);
        state.isDrawing = false;
        state.isFirstActivation = false;
        // 描画完了後、通常アニメーションに移行
        if (state.animationFrameId !== null) {
          cancelAnimationFrame(state.animationFrameId);
          state.animationFrameId = null;
        }
        this.animateInstance(state);
      },
    });
  },

  animateDrawing(state: State) {
    if (!state.lineGroup || !state.renderer || !state.scene || !state.camera) return;

    if (!state.isDrawing) {
      state.animationFrameId = null;
      return;
    }

    state.lineGroup.children.forEach((line) => {
      const material = (line as THREE.Line).material as THREE.ShaderMaterial;
      material.uniforms.time.value += 0.015;
      // drawProgressも毎フレーム更新（GSAPで変更された値を反映）
      material.uniforms.drawProgress.value = state.drawProgress;
    });

    state.camera.lookAt(0, 0, 0);
    state.renderer.render(state.scene, state.camera);
    state.animationFrameId = requestAnimationFrame(() => this.animateDrawing(state));
  },

  checkAndToggleAnimation(state: State) {
    const shouldAnimate = state.isInView && state.isActive;

    // console.log('checkAndToggleAnimation:', state.canvasName, {
    //   shouldAnimate,
    //   isInView: state.isInView,
    //   isActive: state.isActive,
    //   animationFrameId: state.animationFrameId,
    //   isFirstActivation: state.isFirstActivation,
    // });

    // ★ GSAPアニメーションを明示的にキル
    gsap.killTweensOf(state);

    if (shouldAnimate && state.animationFrameId === null) {
      if (state.isFirstActivation) {
        // console.log('→ Starting DRAW animation for:', state.canvasName);
        this.startDrawAnimation(state);
      } else {
        // console.log('→ Starting NORMAL animation for:', state.canvasName);
        this.animateInstance(state);
      }
    } else if (!shouldAnimate && state.animationFrameId !== null) {
      cancelAnimationFrame(state.animationFrameId);
      state.animationFrameId = null;
      state.isDrawing = false;

      // canvasがOFFになったらdrawProgressを0に戻し、次回また描画アニメーションを実行
      // ★ 修正: isActiveがfalseの場合(スライド切り替え)のみリセット
      // isInViewがfalseの場合(画面外)はdrawProgressを1に保持
      if (!state.isActive) {
        // スライドが切り替わった時のみリセット
        state.drawProgress = 0;
        state.isFirstActivation = true;
        if (state.lineGroup) {
          state.lineGroup.children.forEach((line) => {
            const material = (line as THREE.Line).material as THREE.ShaderMaterial;
            material.uniforms.drawProgress.value = 0;
          });
        }
      } else if (!state.isInView) {
        // 画面外の時はdrawProgressを1に設定(完全表示状態)
        state.drawProgress = 1;
        state.isFirstActivation = false;
        if (state.lineGroup) {
          state.lineGroup.children.forEach((line) => {
            const material = (line as THREE.Line).material as THREE.ShaderMaterial;
            material.uniforms.drawProgress.value = 1;
          });
        }
      }
      // console.log('   Canvas turned off, reset drawProgress and isFirstActivation');
    }
  },

  updateActiveStates() {
    states.forEach((state) => {
      const wasActive = state.isActive;
      state.isActive = state.canvasEl.dataset.active === 'true';

      // console.log('updateActiveStates:', state.canvasName, {
      //   wasActive,
      //   isActive: state.isActive,
      //   isFirstActivation: state.isFirstActivation,
      // });

      if (wasActive !== state.isActive) {
        this.checkAndToggleAnimation(state);
      }
    });
  },

  animateInstance(state: State) {
    if (!state.lineGroup || !state.renderer || !state.scene || !state.camera) return;

    const shouldContinue = state.isInView && state.isActive;
    if (!shouldContinue) {
      state.animationFrameId = null;
      return;
    }

    state.lineGroup.children.forEach((line) => {
      const material = (line as THREE.Line).material as THREE.ShaderMaterial;
      material.uniforms.time.value += 0.015;
    });

    state.camera.lookAt(0, 0, 0);
    state.renderer.render(state.scene, state.camera);
    state.animationFrameId = requestAnimationFrame(() => this.animateInstance(state));
  },

  reset() {
    states.forEach((state) => {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }

      if (state.animationFrameId !== null) {
        cancelAnimationFrame(state.animationFrameId);
        state.animationFrameId = null;
      }

      if (state.resizeHandler) {
        window.removeEventListener('resize', state.resizeHandler);
        state.resizeHandler = null;
      }

      if (state.lineGroup) {
        const disposedGeometries = new Set<THREE.BufferGeometry>();
        state.lineGroup.children.forEach((line) => {
          const mesh = line as THREE.Line;
          if (!disposedGeometries.has(mesh.geometry)) {
            mesh.geometry.dispose();
            disposedGeometries.add(mesh.geometry);
          }
          (mesh.material as THREE.ShaderMaterial).dispose();
        });
        state.lineGroup.clear();
        state.lineGroup = null;
      }

      if (state.renderer) {
        state.renderer.dispose();
        state.renderer = null;
      }

      state.scene.clear();
    });
    states.length = 0;

    guiState.gui?.destroy();
    guiState.gui = undefined;
    guiState.guiFrameEl = null;
  },
};
